module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/file-icons/image.svg?c2acaf86ff043866d7d53481b85f3c6c";